import { EAgentLevel, IPageParam } from './common';

export interface IAlipayCompanyListItem {
  id: number;
  /** 支付宝账户编号 */
  accountNo: string;
  /** 企业名称/服务商名称 */
  businessName: string;
  /** 企业编号/服务商编号 */
  businessNo: string;
  /** 绑定支付宝账号(商户登录账号) */
  aliLoginAccount: string;
  /** 可用金额 */
  availableAmount: number;
  /** 充值总金额 */
  rechargeAmount: number;
  /** 总提现金额 */
  withdrawAmount: number;
  /** 状态 */
  signStatus: EAlipayCompanySignStatus;
  /** 异常原因 */
  abnormalReason: string;
  /** 商户签约号 */
  externalAgreementNo: string;
  /** 支付宝唯一用户号 */
  alipayUserId: string;
  /** 支付宝唯一签约号 */
  agreementNo: string;
  /** 签约时间 */
  signTime: string;
  /** 分配给开发者的应用id */
  appId: string;
  /** 分配给商户的应用id */
  authAppId: string;
  /** 代扣协议生效时间 */
  validTime: string;
  /** 外卡卡号 */
  cardNo: string;
  /** 资金记账本id */
  accountBookId: string;
  /** 外卡户名 */
  bankAccName: string;
  /** 外卡支行 */
  cardBranch: string;
  /** 外卡开户行 */
  cardBank: string;
  /** 外卡开户地址 */
  cardLocation: string;
  /** 外卡联行号 */
  cardDeposit: string;
  /** 外卡状态 */
  accountBookStatus?: string;
  /** 状态 */
  zhStatus?: string;
  /** 进件状态 */
  onboardingStatus: EAlipayOnboardingStatus;
    /** 账户状态 */
    accountStatus: EAlipayCompanyAccountStatus;
}

export enum EAlipayCompanySignStatus {
  /** 待签约 */
  PENDING = 0,
  /** 正常 */
  NORMAL = 2,
  /** 异常 */
  ERROR = 3,
}

export const alipayCompanySignStatusLabel = {
  [EAlipayCompanySignStatus.PENDING]: '未签约',
  [EAlipayCompanySignStatus.NORMAL]: '正常',
  [EAlipayCompanySignStatus.ERROR]: '异常',
};

export const alipayCompanySignStatusColor = {
  [EAlipayCompanySignStatus.PENDING]: 'warning',
  [EAlipayCompanySignStatus.NORMAL]: 'success',
  [EAlipayCompanySignStatus.ERROR]: 'danger',
} as any;

export interface IAlipayCompanyListParam extends IPageParam {
  /** 企业名称/服务商名称 */
  businessName?: string;
  /** 企业编号/服务商编号 */
  businessNo?: string;
  /** 绑定支付宝账号 */
  alipayAccount?: string;
  /** 业务类型 */
  businessType?: 'SERVER' | 'COMPANY' | 'AGENT';
}

export interface IAlipayBindParam {
  /** 支付宝账号 */
  alipayAccount: string;
  /** 业务id */
  businessId: number;
  /** 业务类型 */
  businessType: 'AGENT' | 'COMPANY' | 'SERVER';
}

export interface IAlipayWithdrawParam {
  /** 支付宝id */
  accountId: string;
  /** 提现金额 */
  amount: number;
  /** 验证码 */
  code: string;
  /** 手机号 */
  payPhone?: string;
}

export interface IAlipayChargeParam {
  /** 支付宝id */
  alipayAccountId: number;
  /** 支付宝no */
  alipayAccountNo: string;
  /** 充值金额 */
  amount: number;
}

/**
 * 记账本重新开通请求参数
 */
export interface IAlipayAccountReopenRequest {
  /** 支付宝账号编号 */
  accountId: number;
}

export interface IPreTopUpParam extends IPageParam {
  /** 企业id */
  companyId?: number;
  /** 企业编码 */
  companyCode?: string;
  /** 代理商id */
  agentId?: number;
  /** 代理商编码 */
  agentCode?: string;
  /** 余额状态 0:正常 1:低余额 */
  balanceStatus?: 'NORMAL' | 'LOWER';
}

export interface IPreTopUpThresholdParam {
  /** 企业ID */
  companyId?: number;
  /** 代理商ID */
  agentId?: number;
  /** 充值金额 */
  rechargeAmount: number;
  /** 阈值 */
  thresholdBalance: number;
  /** 分账手续费由企业承担? */
  splitFeeBearByEnterprise?: boolean;
}

export interface IPreTopUpListItem extends IPreTopUpThresholdParam {
  /** 预充值帐户ID */
  advanceAccountId: number;
  /** 代理商名称 */
  agentName: string;
  /** 代理商等级 */
  agentLevelType: EAgentLevel;
  /** 企业名称 */
  companyName: string;
  /** 余额状态 0:正常 1:低余额 */
  balanceStatus?: 'NORMAL' | 'LOWER';
  /** 是否显示预充值按钮 */
  showPreTopUp?: boolean;
}

export enum EPreTopUpBalanceStatus {
  /** 正常 */
  NORMAL = 'NORMAL',
  /** 低余额 */
  LOWER = 'LOWER',
}

export const preTopUpBalanceStatusLabel = {
  [EPreTopUpBalanceStatus.NORMAL]: '正常',
  [EPreTopUpBalanceStatus.LOWER]: '低',
};

export const preTopUpBalanceStatusColor = {
  [EPreTopUpBalanceStatus.NORMAL]: 'success',
  [EPreTopUpBalanceStatus.LOWER]: 'danger',
};

export interface IPreTopUpTransactionParam extends IPageParam {
  /** 公司ID */
  companyId?: number;
  /** 代理商ID */
  agentId?: number;
  /** 交易类型 */
  txnType?: EPreTransType;
  /** 交易时间开始 */
  txnTimeBegin?: string;
  /** 交易时间结束 */
  txnTimeEnd?: string;
  /** 企业ID */
  enterpriseId?: number;
}

export interface IPreTopUpTransaction {
  /** 交易类型 RECHARGE：充值 MERCHANT_REGISTER：商户入网 DISTRIBUTION：分账 */
  txnType: EPreTransType;
  /** 交易编号 */
  orderNo: string;
  /** 期初余额 */
  initAmt: number;
  /** 交易金额 */
  txnAmt: number;
  /** 账户金额 */
  finalAmt: number;
  /** 交易时间 */
  txnTime: string;
  /** 关联业务单号 */
  businessNo: string;
  /** 交易补充说明 */
  memo: string;
  /** 操作人 */
  creator: string;
  /** 关联业务单号 */
  createTime: string;
}

export enum EPreTransType {
  /** 充值 */
  RECHARGE = 'RECHARGE',
  /** 商户入网 */
  MERCHANT_REGISTER = 'MERCHANT_REGISTER',
  /** 分账 */
  DISTRIBUTION = 'DISTRIBUTION',
}

export const preTransTypeLabel = {
  [EPreTransType.RECHARGE]: '充值',
  [EPreTransType.MERCHANT_REGISTER]: '商户入网',
  [EPreTransType.DISTRIBUTION]: '分账',
};

export const preTransTypeOptions = Object.values(EPreTransType).map((type) => ({
  label: preTransTypeLabel[type],
  value: type,
}));

export interface IRechargeData {
  /** 预充值帐户ID */
  id: number;
  /** 企业名称 */
  companyName: string;
  /** 代理商名称 */
  agentName: string;
  /** 充值余额 */
  rechargeBalance: number;
  /** 预警阈值 */
  thresholdBalance: number;
  /** 余额状态 */
  status: string;
}

export enum EAlipayCompanyAccountStatus {
  /** 未签约 */
  NOT_SIGNED = 0,
  /** 待进件 */
  PENDING_ONBOARDING = 1,
  /** 审批中 */
  UNDER_REVIEW = 2,
   /** 审批驳回 */
   REJECTED = 3,
    /** 已撤销 */
    REVOKED = 4,
   /** 正常 */
   ACTIVE = 5,
   /** 正常 */
   Abnormal = 6,
}

export const alipayCompanyAccountStatusLabel = {
  [EAlipayCompanyAccountStatus.NOT_SIGNED]: '未签约',
  [EAlipayCompanyAccountStatus.PENDING_ONBOARDING]: '待进件',
  [EAlipayCompanyAccountStatus.UNDER_REVIEW]: '审批中',
  [EAlipayCompanyAccountStatus.REJECTED]: '审批驳回',
  [EAlipayCompanyAccountStatus.REVOKED]: '已撤销',
  [EAlipayCompanyAccountStatus.ACTIVE]: '正常',
  [EAlipayCompanyAccountStatus.Abnormal]: '异常',
};

export const alipayCompanyAccountStatusColor = {
  [EAlipayCompanyAccountStatus.NOT_SIGNED]: 'info',
  [EAlipayCompanyAccountStatus.PENDING_ONBOARDING]: 'primary',
  [EAlipayCompanyAccountStatus.UNDER_REVIEW]: 'warning',
  [EAlipayCompanyAccountStatus.REJECTED]: 'danger',
  [EAlipayCompanyAccountStatus.REVOKED]: 'info',
  [EAlipayCompanyAccountStatus.ACTIVE]: 'success',
  [EAlipayCompanyAccountStatus.Abnormal]: 'danger',
};

export enum EAlipayOnboardingStatus {
  /** 未进件 */
  NOT_ONBOARDED = 0,
  /** 已提交 */
  SUBMITTED = 1,
  /** 已生效 */
  EFFECTIVE = 2,
   /** 进件审核失败 */
   FAILED = 3,
    /** 进件废弃 */
    ABANDONED = 4,

}

export const alipayOnboardingStatusLabel = {
  [EAlipayOnboardingStatus.NOT_ONBOARDED]: '未进件',
  [EAlipayOnboardingStatus.SUBMITTED]: '已提交',
  [EAlipayOnboardingStatus.EFFECTIVE]: '已生效',
  [EAlipayOnboardingStatus.FAILED]: '进件审核失败',
  [EAlipayOnboardingStatus.ABANDONED]: '进件废弃',
};

export const alipayOnboardingStatusColor = {
  [EAlipayOnboardingStatus.NOT_ONBOARDED]: 'info',
  [EAlipayOnboardingStatus.SUBMITTED]: 'warning',
  [EAlipayOnboardingStatus.EFFECTIVE]: 'primary',
  [EAlipayOnboardingStatus.FAILED]: 'danger',
  [EAlipayOnboardingStatus.ABANDONED]: 'info',
};
